class QuickAddBuilderProductCard extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.variantId = this.getAttribute('data-variant-id');
    this.productTitle = this.getAttribute('data-product-title');
    this.productColor = this.getAttribute('data-product-color');
    this.productImage = this.getAttribute('data-product-image');
    this.productHandle = this.getAttribute('data-product-handle');
    this.price = parseInt(this.getAttribute('data-product-price')) || 0;
    this.compareAtPrice = this.getAttribute('data-product-compare-at-price')
      ? parseInt(this.getAttribute('data-product-compare-at-price'))
      : null;
    this.maxItems = this.getAttribute('max-items') ? parseInt(this.getAttribute('max-items')) : null;

    this.onIncreaseClick = this.onIncreaseClick.bind(this);
    this.onDecreaseClick = this.onDecreaseClick.bind(this);
    this.onMoreInfoClick = this.onMoreInfoClick.bind(this);
  }

  static get observedAttributes() {
    return ['quantity', 'total-selected'];
  }

  get quantity() {
    return parseInt(this.getAttribute('quantity')) || 0;
  }
  set quantity(val) {
    const n = Number(val);
    if (!isNaN(n) && n >= 0) this.setAttribute('quantity', n);
  }

  get totalSelected() {
    return parseInt(this.getAttribute('total-selected')) || 0;
  }
  set totalSelected(v) {
    const n = Number(v);
    if (!isNaN(n) && n >= 0) this.setAttribute('total-selected', n);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal === newVal) return;
    if (name === 'quantity' || name === 'total-selected') {
      this.renderStepper();
    }
  }

  connectedCallback() {
    this.infoButton = this.querySelector('.quick-add-builder-card__info_trigger');
    this.infoButton?.addEventListener('click', this.onMoreInfoClick);
    this.stepperContainer = this.querySelector('.quick-add-builder-card__cta_wrapper');
    this.renderStepper();
  }

  disconnectedCallback() {
    this.infoButton?.removeEventListener('click', this.onMoreInfoClick);
  }

  /**
   * Batch-update multiple attributes at once.
   * @param {Object} props — key/value pairs to set as attributes
   */
  updateProperties(props = {}) {
    Object.entries(props).forEach(([key, val]) => {
      if (key in this) this[key] = val;
      else this.setAttribute(key, val);
    });
  }

  renderStepper() {
    if (!this.stepperContainer) return;
    this.stepperContainer.innerHTML = '';

    const qty = this.quantity;
    const atMax = this.maxItems != null && this.totalSelected >= this.maxItems;

    const wrapper = document.createElement('div');
    wrapper.className = 'quick-add-builder-stepper';

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'quick-add-builder-stepper__decrease';
    minus.textContent = '–';
    minus.disabled = qty === 0;
    minus.setAttribute('aria-label', `Decrease ${this.productTitle} quantity`);
    minus.addEventListener('click', this.onDecreaseClick);

    const count = document.createElement('span');
    count.className = 'quick-add-builder-stepper__count';
    count.textContent = qty;

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'quick-add-builder-stepper__increase';
    plus.textContent = '+';
    plus.disabled = atMax;
    plus.setAttribute('aria-label', `Increase ${this.productTitle} quantity`);
    plus.addEventListener('click', this.onIncreaseClick);

    wrapper.append(minus, count, plus);
    this.stepperContainer.appendChild(wrapper);
  }

  onIncreaseClick() {
    this.dispatchEvent(
      new CustomEvent('quick-add-builder-add-item', {
        detail: {
          productId: this.productId,
          variantId: this.variantId,
          productTitle: this.productTitle,
          productColor: this.productColor,
          productImage: this.productImage,
          price: this.price,
          compareAtPrice: this.compareAtPrice,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  onDecreaseClick() {
    this.dispatchEvent(
      new CustomEvent('quick-add-builder-remove-item', {
        detail: {
          productId: this.productId,
          variantId: this.variantId,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  onMoreInfoClick(event) {
    event.preventDefault();
    const moreInfoPanel = document.querySelector('more-info-panel');
    if (!moreInfoPanel) return;
    moreInfoPanel.updateProperties({
      productHandle: this.productHandle,
    });

    moreInfoPanel
      .loadMainProduct()
      .then(() => {
        moreInfoPanel.open(this);
      })
      .catch((err) => {
        console.error('Error loading product info:', err);
      });
  }
}
if (!customElements.get('quick-add-builder-product-card')) {
  customElements.define('quick-add-builder-product-card', QuickAddBuilderProductCard);
}
